import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-full-width-container',
  templateUrl: './full-width-container.component.html',
  styleUrls: ['./full-width-container.component.scss']
})
export class FullWidthContainerComponent implements OnInit {

  public fullWidth: boolean = false;

  // @ts-ignore
  private $tabContainer = document.querySelector('#tab-container');

  constructor() { }

  ngOnInit(): void {

  }

  toggle() {
    const className = 'full-width';
    const classNames = this.$tabContainer.className.split(' ');
    if (classNames.indexOf(className) > -1) {
      this.$tabContainer.className = classNames.filter(cn => cn != className).join(' ');
    } else {
      classNames.push(className);
      this.$tabContainer.className = classNames.join(' ');
    }
  }

}
